import withAdminTheme from "../hoc/withAdminTheme"
import AdminLayout from './AdminLayout';

export default withAdminTheme(AdminLayout);